import { createSelector } from 'reselect';

export const Types = {
  GET_REQUEST: 'stores/GET_REQUEST',
  GET_SUCCESS: 'stores/GET_SUCCESS',
  GET_FAILURE: 'stores/GET_FAILURE',

  GET_LIST_REQUEST: 'stores/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'stores/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'stores/GET_LIST_FAILURE',

  UPDATE_REQUEST: 'stores/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'stores/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'stores/UPDATE_FAILURE',

  GET_STATES_REQUEST: 'stores/GET_STATES_REQUEST',
  GET_STATES_SUCCESS: 'stores/GET_STATES_SUCCESS',
  GET_STATES_FAILURE: 'stores/GET_STATES_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  update: {
    loading: false,
  },

  states: {
    data: [],
    loading: false,
  },
};

export default function stores(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.store.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.stores.data,
        page: action.payload.stores.meta.current_page,
        totals: action.payload.stores.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.GET_STATES_REQUEST:
      return {
        ...state,
        states: {
          ...state.states,
          loading: true,
        },
      };
    case Types.GET_STATES_SUCCESS:
      return {
        ...state,
        states: {
          ...state.states,
          data: action.payload.states.data,
          loading: false,
        },
      };
    case Types.GET_STATES_FAILURE:
      return {
        ...state,
        states: {
          ...state.states,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getStoreRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getStoreSuccess: store => ({
    type: Types.GET_SUCCESS,
    payload: { store },
  }),

  getStoreFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getStoresRequest: (page = 1, filter = '') => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page, filter },
  }),

  getStoresSuccess: stores => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { stores },
  }),

  getStoresFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  updateStoreRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateStoreSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateStoreFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  getStoreStatesRequest: () => ({
    type: Types.GET_STATES_REQUEST,
  }),

  getStoreStatesSuccess: states => ({
    type: Types.GET_STATES_SUCCESS,
    payload: { states },
  }),

  getStoreStatesFailure: () => ({
    type: Types.GET_STATES_FAILURE,
  }),
};

export const Selectors = {
  options: createSelector(
    state => state,
    stores => stores.map(store => ({ value: store.id, label: store.attributes.name })),
  ),

  states: createSelector(
    state => state,
    states => states.map(state => ({ value: state.id, label: state.attributes.name })),
  ),
};
